/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { Column, Row } from '../../layout/components/dom'
import { useSession } from '../../utility/Auth'
import { useGlobal } from '../../utility/CTX';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ContactButton, RoadmapButton } from '../../layout/components/button';
import { isDesktop } from '../../utility/assist';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../utility/firebase';
import { getAuth }  from 'firebase/auth';
import { FaReddit } from 'react-icons/fa';
import { Helmet } from 'react-helmet';









function Download() {
        const session = useSession();
        const { theme } = useGlobal();
        const [version, setVersion] = useState({}); // Replace with your app's current version




        const desktop = useMemo(() => {
            return isDesktop();
        }, []);

     

        useEffect(() => {

            fetch('/version.json')
                .then(async (res) => {
                    let data = await res.json()
                    setVersion(data)
                })
                .catch((err) => {});
        }, []);





            
        return <Column style={{alignItems: 'center'}}>
            <Helmet>
                <title>Download - Gateway Forge</title>
                <meta name="description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />
                <meta property="og:url" content="https://gatewayforge.com/download" />
                <meta property="og:title" content="Download - Gateway Forge" />
                <meta property="og:description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />

            </Helmet>
            
            <Row style={{color: theme.yellow, fontSize: '1.2em', margin: `20px 20px 10px 20px`}}>
                <div>Alpha Testing</div>
                <div style={{color: theme.green, marginLeft: 10}}>{`(Open)`}</div>
            </Row>
            
            {!session && <Column style={{margin: 50}}>
                <AccountButton />
            </Column>}
            

            {session && <Column style={{alignItems: 'center', maxWidth: 600, minWidth: '90%'}}>
                <h1>Current Version</h1>
                <Row style={{marginBottom: 10, fontSize: '1.2em', justifyContent: 'end'}}>Alpha {version?.version}</Row>
                <Row style={{justifyContent: 'space-between', margin: 20, width: 300}}>
                    <div>Mac</div>

                    {desktop && <Row>
                        <DownloadLink version='mac' text='.zip' linkTo={version?.mac || ''} marginRight={20} />
                    </Row>}
                    {!desktop && <Row style={{color: theme.red}}>
                        Desktop Only
                    </Row>}
                </Row>
                <Row style={{justifyContent: 'space-between', margin: 20, width: 300}}>
                    <div>Windows</div>

                    {desktop && <div>
                        <DownloadLink version='win' text='.zip' linkTo={version?.win || ''} marginRight={20} />
                    </div>}
                    {!desktop && <Row style={{color: theme.red}}>
                        Desktop Only
                    </Row>}
                </Row>

                <Column style={{maxWidth: 250, margin: '10px auto', textAlign: 'center'}}>
                    <b style={{color: theme.red, marginRight: 5}}>MAC USERS:</b>
                    <div>You may need to access: <br/><b>System Settings</b>{' > '}<b>General</b>.</div>
                    <div>to open the software.</div>
                </Column>


                <Column style={{margin: '20px auto', maxWidth: 300, textAlign: 'center'}}>
                    <p>Stay up to date on current and upcoming developments:</p>
                    <Column style={{margin: 'auto', alignItems: 'center'}}>
                        <RoadmapButton />
                        <Row style={{fontSize: '1.8em', marginTop: 15, color: theme.orange}}>
                            <FaReddit />
                        </Row>
                    </Column>
                </Column>

                <Column style={{margin: '5px auto', maxWidth: 300, textAlign: 'center'}}>
                    <p>For older versions, please reach out and inquire:</p>
                    <Row style={{margin: 'auto'}}>
                        <ContactButton />
                    </Row>
                </Column>
            </Column>}
        
        </Column>
};






const DownloadLink = ({version, text, linkTo, marginRight}) => {
    const { theme } = useGlobal();
    
    const [hover, setHover] = useState(false);



    const handleClick = useCallback((e) => {
        let auth = getAuth();
        let user = auth.currentUser;
        logEvent(analytics, 'download', {
            userId: user?.uid,
            version
        })
    }, [version]);



    return <a download
    style={{
            marginRight, 
            color: theme.orange, 
            cursor: 'pointer', 
            padding: '2px 15px', 
            borderRadius: 40, 
            border: `1px solid ${hover ? theme.orange : theme.border}`, 
            background: hover ? theme.bg3 : theme.bg2
    }} href={linkTo}
    onClick={handleClick}
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}>
        {text}
    </a>
}





const AccountButton = () => {
    const { theme, dispatch } = useGlobal();
    const [ hover, setHover ] = useState(false);

    return <div style={{margin: 'auto 15px', background: hover ? theme.bg4 : theme.bg2, padding: '5px 10px 5px 15px', border: `1px solid ${hover ? theme.orange : theme.border}`, borderRadius: 50, width: 'auto', cursor: 'pointer'}} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        <Link style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            textWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 5,
            borderRadius: 5,
            textAlign: 'center',
            color: theme.orange,
            fontWeight: 400,
            cursor: 'pointer'
        }} to='/auth' onClick={(e) => dispatch({ type: 'SET_PAGE', page: 'Auth'})}>Free Account <span className='material-symbols-rounded'>chevron_right</span></Link>
    </div>
}




export default Download